/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "5ec445d9c4ed16f4114f86d392da059c6209e9d7";
